export const ShareSpaceDialogService = Symbol('ShareSpaceDialogService');
